/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = window.jQuery = require( 'jquery' );

// Import libraries
require( 'lazysizes' );
import mediumZoom from 'medium-zoom';
import RewardBlock from './modules/reward-block.js';

new RewardBlock();

mediumZoom( document.querySelectorAll( '.data-zoomable:not(.no-zoom)' ), {
	margin: 10,
	background: '#333',
	scrollOffset: 0
});
